import FormFieldProps from '../v2/common/form-field'
import { STANDARD_PASSWORD, STANDARD_USERNAME } from '@App/forms/v2/common/generic-form-field-props'
import { FormFieldTypes } from '@App/enum/form-field-types'

export const MFA_LABEL = 'Code'

interface LoginFormProps {
    username: FormFieldProps
    password: FormFieldProps
    code: FormFieldProps
}

export const userLoginFormFields: LoginFormProps = {
    username: STANDARD_USERNAME,
    password: STANDARD_PASSWORD,
    code: {
        name: 'code',
        label: MFA_LABEL,
        type: FormFieldTypes.TEXT,
    },
}
